<template lang="pug">
	.step
		.step__outer-item(v-for="(item, index) in insuredPeople", :key="index")
			.step__title
				|Укажите данные застрахованного №{{index + 1}}
				.checkbox.checkbox_step3(v-if="index === 0")
					input.checkbox__control(type="checkbox", @change="handleCheckboxChange", name="owner", id="checkbox-owner")
					label.checkbox__label(for="checkbox-owner")
						span.checkbox__icon
						span.checkbox__text-content
							|Совпадает со страхователем
			.step__list
				.step__item.step__item_large
					.step__item-right
						app-suggestion(:input="schema.insurerName", @handleInput="handleInput($event, 'name', index)", :index="index", :model.sync="item.FIO",:options="suggestionOptions", @change="suggestionChange")
						//- app-input(:input="schema.insuredPeopleName", :field.sync="item.name" @input="handleInput($event, 'name', index)")
				.step__item.step__item_large
					.step__item-right
						app-input(:input="schema.insuredPeopleBirthDate", :index="index", :field.sync="item.BIRTHDAY",  @input="handleInput($event, 'date', index)")

		.step__button( :class="$style.step__button")
			.step__button-block
						.step__text-summ
							|Стоимость полиса {{totalCost | numeric}} ₽
			.step__buttons( :class="$style.step__buttons")
				a.button.button_type-simple( :class="$style.button_type" href="#",  @click.prevent="handleClickPrev")
					|<-
				a.button( :class="$style.button" href="#", ref="buttonNext", @click.prevent="handleClick")
					|Далее
</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import AppSuggestion from '@/components/Suggestion.vue'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import  $ from 'jquery';
export default {

  name: 'app-step3',
  components: {
    AppInput,
    AppSuggestion
  },
  created(){
  	// for(let i = 0; i < this.count; i++) {
  	// 	this.insuredPeople[i] = {
  	// 		name:'',
  	// 		date:''
  	// 	}
  	// }
  },
  data() {
  	return {
  		suggestionOptions: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: '4e29d51c4d938ea6f685cb0a0bed225fbba9e3ee',
        type: "NAME",
        scrollOnFocus: false,
        triggerSelectOnBlur: true,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        onSelect:(suggestion) => {
        	console.log(this, suggestion)

        	setTimeout(() => {
        		let people = this.insuredPeople.filter(item => item.FIO === suggestion.unrestricted_value)
	        	people.forEach(el => {
	        		el.SEX = suggestion.data.gender[0]
	        	})
        	},0)
        	// console.log(123, suggestion)
        	// console.log(this.insuredPeople)
        	// console.log('selected',suggestion, this)
        	// this.insurerName = `${suggestion.data.surname} ${suggestion.data.name} ${suggestion.data.patronymic}`
        },
        onSelectNothing(suggestion){
        	// this.value = '';
        }
      },
  	}
  },
  methods:{
  	handleClick(){
  		this.$validator.validate().then(valid => {
        if (valid) {
           this.$router.push({name:'step4'})
           console.log()
           $('body, html').animate({
           	scrollTop: $('.banner__description').offset().top
           },300);
        }
      })
		},
		handleInput(value, name, index) {
			console.log(this.insuredPeople)
		},
		handleCheckboxChange(e){
			if(e.target.checked) {
				this.$set(this.insuredPeople[0], 'FIO', this.insurerName)
				this.$set(this.insuredPeople[0], 'BIRTHDAY', this.insurerBirthDate)
				this.$set(this.insuredPeople[0], 'SEX', this.insurerGender)
			}
  		console.log(this.insuredPeople)
		},
		suggestionChange(e){
			console.log(e)
		},
		handleClickPrev(){
			this.$router.push({name:'step2'})
		}
  },
  computed:{
  	...mapFields([
      'count',
      'insuredPeople',
      'insurerGender',
	  'totalCost'
    ]),
    ...mapGetters({
		  schema: 'getSchema',
		  // popupIsActive: 'PopupIsActive',
		  insurerBirthDate:'getBirthDate',
		  insurerName:'getInsurerName'
		}),

  }
}
</script>

<style lang="scss">
.text ~ div {
	color:red;
}
	.checkbox {
		&_step3 {
			padding-top: 7px;
		}
		&_step4 {
			.checkbox__label {
				font-size: 14px;
				line-height: 12px;
			}
		}
		&__control {
			display: none;
			&:checked ~ .checkbox__label .checkbox__icon {
				background-color: #04a4b0;
				background-image: url(../assets/img/checkbox.svg);
				background-size: 50%;
				background-position: center center;
				background-repeat: no-repeat;
			}
		}
		&__label {
	    margin-top: 20px;
	    font-size: 15px;
	    line-height: 23px;
	    color: #808080;
	    cursor:pointer;
	    display: flex;
		align-items: flex-start;
	    user-select:none;
		}

		&__icon {
			display: inline-block;
			flex-shrink: 0; 
			width: 20px;
			height: 20px;
			border: 1px solid #04a4b0;
			border-radius: 4px;
			margin-right: 8px; 
			box-sizing: border-box;
			transition: background-color .2s, background-image .2s;
		}

		&__text-content {

		}


		&_step4 {
			.checkbox__label {
				font-size: 14px;
				line-height: 12px;
			}
			// .checkbox__icon {
		
			// }
		}
	}


</style>

<style module lang="scss">
.button {
	width: 100%;
}
.step__button {

	flex-direction: column;

	display: flex;
	justify-content: space-between;;
}
.button_type {
	min-width: 54px;
	padding: 0 !important;
	height: 54px !important;
	width: 54px !important;
	border: solid #b9b9b9 1px;
    color: #6C6F71;
    font-weight: 700;
    background-color: #ecf1f7;
}
.step__buttons {
	justify-content: flex-end !important;
	max-width: 740px;
	width: 100%;
	gap: 15px;
	display: flex;
}
</style>

<style lang="scss">
.step__text-summ {
	color: #848199;
	font-weight: 600;
	font-size: 17px;
}
</style>
